module.exports = __webpack_public_path__ + "img/报装.38e87ab1.png";